import { Breadcrumb } from "antd";
import { useLocation } from "react-router-dom";
import { FC, memo, useCallback, useMemo } from "react";
import { NonIndexRouteObject } from "react-router/dist/lib/context";
import { useNavigate } from "react-router";
import "./index.less";
// 定义router数组类型，可修改[只需传需要用的数组不需要用的不要传]
interface RulesRouterObject extends NonIndexRouteObject {
  rules?: string[];
  show?: boolean;
  label?: string;
  children?: RulesRouterObject[];
}

const MineBreadcrumb: FC<{ router: RulesRouterObject[] }> = memo(
  ({ router }) => {
    const location = useLocation();
    const navigate = useNavigate();

    // 每次都会执行这个操作去过滤location,memo优化除了location.pathname变化以外的变化都不会改变
    const pathSnippets = useMemo(() => {
      return location.pathname.split("/").splice(1);
    }, [location.pathname]);
    // 递归处理数据 - 因为初始化之后基本不会再去调用这里做useCallback缓存函数体本身
    const filterRouterListFn = useCallback((router: RulesRouterObject[]) => {
      const items: { [k: string]: string } = {};
      const processRouter = (router: RulesRouterObject[]) => {
        for (let i = 0; i < router.length; i++) {
          const newPath = router[i].path;
          items[newPath] = router[i].label as string;
          if (router[i].children) {
            processRouter(router[i].children as RulesRouterObject[]);
          }
        }
      };
      processRouter(router);
      return items;
    }, []);

    // 缓存函数返回值memo优化除非router变化否则不会重新执行代码
    const filterRouterList = useMemo(() => {
      return filterRouterListFn(router);
    }, [filterRouterListFn, router]);

    // 如果当前路由跟点击路由一致那么就出发刷新
    const changPage = useCallback(
      (url: string) => {
        //   处理按钮页面
        if (url.includes(location.pathname)) {
          window.location.reload();
        } else {
          navigate(url);
        }
      },
      [location.pathname, navigate]
    );

    // 每次因为pathSnippets都会变化所以每次下面调用changItems的时候都会重新执行这段代码触发渲染
    const changItems = useMemo(() => {
      return pathSnippets
        .map((_, index) => {
          const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;
          if (filterRouterList[url]) {
            return {
              key: url,
              title: (
                <a
                  // className={styles.breadcrumbItem}
                  onClick={() => {
                    if (index !== 0) {
                      changPage(url);
                    }
                  }}
                >
                  {filterRouterList[url]}
                </a>
              ),
            };
          } else {
            return { key: "false", title: <a>false</a> };
          }
        })
        .filter((item) => item.key !== "false");
    }, [changPage, filterRouterList, location.pathname, pathSnippets]);
    return (
      <Breadcrumb className="breadCrumb">
        {changItems.map((item) => {
          return <Breadcrumb.Item key={item.key}>{item.title}</Breadcrumb.Item>;
        })}
      </Breadcrumb>
    );
  }
);
export default MineBreadcrumb;
